import { lazy } from "react";

export const AccountSubscriptionAsync = lazy(() => import("./AccountSubscription"));
